import React, {Component} from 'react';
import { connect } from 'dva';
import { Input } from 'antd';
import BaseComponent from '../../../components/BaseComponent';
//import LocationSearch from '../../../components/LocationSearch';
import config from '../config/config';
const {travel} = config;

class SearchKeyword extends BaseComponent {
  constructor(props) {
    super(props);
    this.onSearch = this.onSearch.bind(this);
  }

  /*
  componentWillMount() {
    const {dispatch} = this.props;
  }
  */

  onSearch(q){
    const {dispatch} = this.props;

    const query = {q: q};
    const self = this;

    const opt = {
      query: query,
      onSuccess({data, meta}) {
        console.info(data);

        dispatch({
          type: 'travel/search',
          items: data,
          keyword: query
//          meta: meta
        });

      },
      onError(error) {

      }
    }

    this.load(travel.api.travelSearch, opt);

  }

  render() {
    const {travel} = this.props;
//    const {tMeta} = travel;

    return(
      <div>
        <Input.Search
          placeholder="検索"
          defaultValue='グリーン'
          onSearch={this.onSearch}
          enterButton
        />
      </div>
    )
  }
}

export default connect(({ travel }) => ({
  travel
}))(SearchKeyword);



// WEBPACK FOOTER //
// ./src/pages/travel/components/SearchKeyword.js